<template>
  <div id="kakaoContent" :class="isIntroduce ? `cont_introduce ${pageName}` : `cont_sub ${pageName}`">
    <div id="mArticle">
      <!-- <div class="section_comm">
        <div class="head_section"> -->
          <!-- <slot name="pageInfo"/> -->
          <!-- <ProgressState v-if="progressDataList" :progressDataList="progressDataList"/> -->
        <!-- </div>
        <div class="body_section"> -->
          <slot />
        <!-- </div>
      </div>
      <slot name="sticky"/> -->
    </div>
  </div>
</template>

<script>
// import SharedPageAuthMixin from '@/mixins/SharedPageAuthMixin';
// import { mapState } from 'vuex';

// import LocalStorageManager from '~/storages/LocalStorageManager';

// import ProgressState from '@/components/common/progressState/ProgressState'
export default {
  name: 'Content',
  // mixins: [SharedPageAuthMixin],
  components:{
    // ProgressState
  },
  props: {
    // pageTitle: String,
    progressDataList: Array
    // isTabAuth: Boolean,
    // isAdmin: Boolean,
  },
  computed: {
    isIntroduce(){
      const menuId = this.$route.meta.menuId;
      return menuId === 'introduce' || menuId === 'partner';
    },
    pageName() {
      return this.$route.meta.menuId;
    },
  },
}
</script>
<style scoped>
.cont_introduce{min-height:calc(100% - 260px);box-sizing:border-box}
.cont_sub{min-height:calc(100% - 260px);padding:80px 0 0;box-sizing:border-box}
</style>
